import './index.css';
import './styles/vibe-tokens.css';
import './styles/vibe-home.css';
import './styles/home-chat-morph.css';
import 'agentable-canvas/orchestration/tokens.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { bootstrapOAuthCallbackRoute } from './lib/auth-callback-exchange';
import { enforceCanonicalDevOrigin } from './lib/auth-utils';

enforceCanonicalDevOrigin();
bootstrapOAuthCallbackRoute();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
